import Cookies from 'js-cookie';
import { signaler } from './signaler';
import { rollbar } from './rollbar';

export const DEFAULT_SERVICE_NUMBER = '800-293-4232';

export async function getServiceNumber() {
  const ttarpOverrideCookie = Cookies.get('ttarp_override');
  try {
    const ttarpTestFlag = signaler.featureFlag('ttarp_test_v2');

    if (ttarpTestFlag === 'test') {
      if (ttarpOverrideCookie === '855-792-1402') {
        return '844-222-8343'; // Test HVPR number
      } else if (ttarpOverrideCookie !== undefined && ttarpOverrideCookie !== '') {
        return ttarpOverrideCookie; // cookie overrideable
      } else {
        return '855-271-2660'; // Test phone number
      }
    } else if (ttarpTestFlag === 'control') {
      if (ttarpOverrideCookie === '855-792-1402') {
        return '844-221-2538'; // Control HVPR number
      } else if (ttarpOverrideCookie !== undefined && ttarpOverrideCookie !== '') {
        return ttarpOverrideCookie; // cookie overrideable
      } else {
        return '855-256-1652'; // Control phone number
      }
    }
  } catch (error) {
    rollbar.error('Error fetching feature flag:', error);
  }

  return ttarpOverrideCookie ? ttarpOverrideCookie : DEFAULT_SERVICE_NUMBER;
}
